import { useTranslation } from 'react-i18next'
import Typography from '@mui/material/Typography'

const ContentSearchGuide = () => {
    const { t } = useTranslation()

    return (
        <>
            <Typography>{t('ALERT.CONTENT.SEARCH_GUIDANCE.1')}</Typography>
            <Typography>{t('ALERT.CONTENT.SEARCH_GUIDANCE.2')}</Typography>
            <Typography style={{ paddingLeft: '1.5em' }}>{t('ALERT.CONTENT.SEARCH_GUIDANCE.2-1')}</Typography>
            <Typography style={{ paddingLeft: '1.5em' }}>{t('ALERT.CONTENT.SEARCH_GUIDANCE.2-2')}</Typography>
            <Typography>
                <label style={{ color: '#d32f2f' }}>*</label> {t('ALERT.CONTENT.SEARCH_GUIDANCE.PS-1')}
            </Typography>
            <Typography>
                <label style={{ color: '#d32f2f' }}>**</label> {t('ALERT.CONTENT.SEARCH_GUIDANCE.PS-2')}
            </Typography>
        </>
    )
}

export default ContentSearchGuide
